"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetApiClient = void 0;

var _react = require("react");

var _apiContext = require("../apiContext");

var useGetApiClient = function useGetApiClient() {
  var _useContext = (0, _react.useContext)(_apiContext.apiContext),
      api = _useContext.api;

  return api;
};

exports.useGetApiClient = useGetApiClient;